import ImageViewer from "@/components/image-viewer";

export default function ImageViewerTemplate() {
    return <ImageViewer />;
}
